import {Component} from '@angular/core';

import {CovIconComponent, IconName} from '@cov/ui-angular';

@Component({
  selector: 'cov-inquiry-topic-button',
  imports: [CovIconComponent],
  templateUrl: './inquiry-topic-button.component.html',
  styleUrl: './inquiry-topic-button.component.scss',
})
export class InquiryTopicButtonComponent {
  protected readonly IconName = IconName;
}
